module.exports = __webpack_public_path__ + "img/k2.6d21a8ae.png";